export const getDefault = () => {
  const schema = {
    name: 'News',
    backgroundColor: '#F1F1F2',
    textColor: '#000',
    title: 'Notícias',
    resource: 'app.organism.news.title',
    showHeader: true,
    titleProps: {
      hasLine: false,
      hasLink: true,
      href: 'https://uaonline.ua.pt'
    },
    cardStyles: {
      textColor: '#000',
      backgroundColor: '#fff'
    },
    featured: true,
    channel: 57,
    recordsPerPage: 6,
    categoriesToIgnore: [],
    categories: [
      11,
      9,
      1,
      16,
      4,
      12,
      13,
      8
    ],
    tag: [192]
  }
  return schema
}
